import React from 'react'

export default function IconAudience({ size = '1em', style = {}, fill = 'currentColor', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      style={style}
      fill={fill}
      viewBox="0 0 50 50"
      {...rest}
    >
      <path
        fill={fill}
        d="M10.058 10.03a5.47 5.47 0 017.064 4.176.781.781 0 001.535-.293 7.031 7.031 0 10-10.555 7.329 12.465 12.465 0 00-6.346 4.46.781.781 0 101.251.934 10.898 10.898 0 018.73-4.373h.018a.785.785 0 00.65-.346.781.781 0 00-.65-1.217h-.017a5.469 5.469 0 01-1.68-10.67zM36.93 9.934A5.47 5.47 0 1138.3 20.7H38.281a.781.781 0 100 1.563h.019a10.897 10.897 0 018.73 4.373.781.781 0 101.251-.935 12.46 12.46 0 00-6.346-4.459l.114-.07a7.031 7.031 0 10-10.669-7.26.781.781 0 001.535.294 5.469 5.469 0 014.013-4.272z"
      ></path>
      <path
        fill={fill}
        fillRule="evenodd"
        d="M25 17.575a8.594 8.594 0 00-3.947 16.23 13.298 13.298 0 00-8.005 6.865.781.781 0 001.404.685 11.739 11.739 0 0121.096 0 .781.781 0 101.404-.685 13.3 13.3 0 00-8.005-6.866A8.594 8.594 0 0025 17.574zm-7.031 8.594a7.031 7.031 0 1114.062 0 7.031 7.031 0 01-14.062 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  )
}
